document.addEventListener('DOMContentLoaded', () => {
  const cartItemsContainer = document.querySelector('.cart-drawer');
  const freeProductId = 42571603411079;

  // Delegated event listener (handles future checkboxes too)
  document.addEventListener('change', function (event) {
    
    const checkbox = event.target;
    if (!checkbox.classList.contains('subscribe-reminder-checkbox')) return;
    event.stopImmediatePropagation(); // Prevent interference
    console.log("checkbox clicked");
    handleCheckboxChange(event); // Main logic
    handleSubscribeCheckboxInit(checkbox); // Populate dropdown etc.

     
    const errdiv = document.getElementById("CartDrawer-CartErrors");
    if (errdiv) {
      console.log("hide error div");
      errdiv.style.display = "none";
    }
  });

  function handleSubscribeCheckboxInit(checkbox) {
    const productHandle = checkbox.dataset.handle;
    const productKey = checkbox.dataset.key;

    if (!productHandle) {
      console.error('Product handle not found for checkbox');
      return;
    }

    // Find the cart row that matches this product key
    const cartItemRow = document.querySelector(`.cart-item__details[data-key="${productKey}"]`);

    // Extract the Reorder Plan ID (selling_plan) from the product link
    let selectedPlanId = null;
    if (cartItemRow) {
      const productLink = cartItemRow.querySelector('a[href*="selling_plan="]');
      if (productLink) {
        const urlParams = new URLSearchParams(productLink.getAttribute('href').split('?')[1]);
        selectedPlanId = urlParams.get('selling_plan');
      }
    }

    console.log("selectedPlanId " + selectedPlanId);


    fetch(`/products/${productHandle}.js`)
      .then((response) => response.json())
      .then((product) => {
        const sellingPlans = product.selling_plan_groups || [];
        const dropdown = document.querySelector(`.reminder-options[data-key="${checkbox.dataset.key}"]`);
        const phoneInputContainer = document.querySelector(`.phone-input[data-key="${checkbox.dataset.key}"]`);

         // Filter for "Dropstreet Reminders" group only
        const dropstreetGroup = sellingPlans.find(group => group.name === "Dropstreet Reminders");
        
        if (dropdown && sellingPlans.length > 0) {
          dropdown.innerHTML = '<option value="">--please select--</option>';

          
            dropstreetGroup.selling_plans.forEach((plan) => {
              const deliveryFrequency = plan.options[0]?.value || "N/A";
              const isSelected = (selectedPlanId && selectedPlanId == plan.id) ? 'selected' : '';

              if (selectedPlanId == plan.id) {
                console.log("found!");
              }

              dropdown.innerHTML += `
                <option 
                  value="${plan.id}" 
                  data-plan-name="${plan.name}" 
                  data-delivery-frequency="${deliveryFrequency}"
                  ${isSelected}>
                  ${plan.name} - ${deliveryFrequency}
                </option>
              `;
            });
         

          if (checkbox.checked) {
            dropdown.classList.remove('hidden');
            phoneInputContainer.classList.remove("hidden");
            if (selectedPlanId) {
              dropdown.value = selectedPlanId;
            }
          } else {
            dropdown.classList.add('hidden');
            phoneInputContainer.classList.add("hidden");
          }
        }
      })
      .catch((error) => console.error('Error fetching product details:', error));
  }

 formatPhoneNumber = function(phone) {
  // Remove all non-digit characters
  phone = phone.replace(/\D/g, '');

  // Limit to first 10 digits
  phone = phone.substring(0, 10);

  // Return formatted with +1 prefix
  return '+1' + phone;
}

  
 const dropdownListeners = new Map();

function handleCheckboxChange(event) {
  console.log("check box change event");
  const checkbox = event.target;
  const productKey = checkbox.dataset.key;
  const productId = checkbox.dataset.id;
  const cartItemDetails = document.querySelector(`.cart-item__details[data-key="${productKey}"]`);
  const regularVariantId = cartItemDetails?.getAttribute('data-id');
  const dropdown = document.querySelector(`.reminder-options[data-key="${productKey}"]`);
  const phoneInputContainer = document.querySelector(`.phone-input[data-key="${productKey}"]`);

  if (checkbox.checked) {
    // If already listening, remove old one first just in case
    if (dropdownListeners.has(productKey)) {
      dropdown.removeEventListener('change', dropdownListeners.get(productKey));
    }

    // Define and store the listener
    const onDropdownChange = function () {
      console.log("on dropdown change");
      const selectedOption = this.options[this.selectedIndex];
      handleSubscription(
        regularVariantId,
        productKey,
        selectedOption.value,
        selectedOption.dataset.planName,
        selectedOption.dataset.deliveryFrequency,
        formatPhoneNumber(phoneInputContainer.value)
      );
    };

    dropdownListeners.set(productKey, onDropdownChange);
    dropdown.addEventListener('change', onDropdownChange);

    dropdown.classList.remove('hidden');
    phoneInputContainer.classList.remove('hidden');
  } else {
    if (dropdownListeners.has(productKey)) {
      dropdown.removeEventListener('change', dropdownListeners.get(productKey));
      dropdownListeners.delete(productKey); // Clean up
    }

    dropdown.classList.add('hidden');
    phoneInputContainer.classList.add('hidden');

    if (regularVariantId) {
      removeSubscription(productKey, productId, regularVariantId);
    } else {
      console.error("Regular Variant ID is missing!");
    }
  }

  
}


  function handleSubscription(productId, productKey, planId, planName, planInterval,phoneNumber) {
    console.log("Switching to subscription:", { productId, productKey, planId, planName, planInterval });

     // Find the current quantity of the item in the cart
  const quantityInput = document.querySelector(`input.quantity__input[data-quantity-variant-id="${productId}"]`);
  const currentQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1; // Default to 1 if not found
 // const phoneNumber  = document.querySelector("#phone-input").value;


    fetch(`/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [productKey]: 0 }
        }),
      })
      .then(() => {
        // Add subscription product
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: productId,
            quantity: currentQuantity,
            selling_plan: planId,
            properties: {
             // 'Re-order Reminder Plan ID': planId,
             // 'Plan Name': planName,
            //  'Re-order Reminder Interval': planInterval,
              'Phone Number': phoneNumber
            },
          }),
        });
      })
      .then(response => response.json())
      .then(subscriptionItem => {
        console.log("Subscription added:", subscriptionItem);
        updateCartUI(subscriptionItem, "subscription");
      
        //  Add Re-order Text Reminders product
     /*  return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: freeProductId, // <-- this should be the VARIANT ID
            quantity: 1
          })
        });*/
      })
    //  .then(response => response.json())
     /* .then(reminderItem => {
        console.log("Reminder item added:", reminderItem);
        
      })*/
      .catch(error => console.error("Error handling subscription:", error));

  }

 function removeSubscription(productKey, productId, regularVariantId) {
  console.log("Switching back to regular product:", { productKey, productId, regularVariantId });

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const updates = {};
      updates[productKey] = 0; // Remove subscription

   return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      });
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: regularVariantId,
          quantity: 1,
        }),
      });
    })
    .then((response) => response.json())
    .then((data) => {
      console.log("Regular product added:", data);
      updateCartUI(data, "regular"); // Your own UI function
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch((error) => console.error("Error updating cart:", error));
}



// Phone Number Validation on Input Change
  const phoneInput = document.querySelector("#phone-input");
  const errorMessage = document.querySelector(".error-message");
/*
  function validatePhone(phone) {
    const phoneRegex = /^\+?[1-9]\d{1,14}$/; // Validates international numbers
    return phoneRegex.test(phone);
  }
*/
window.formatPhoneInput = function(input) {
  // Remove all non-digit characters
  let digits = input.value.replace(/\D/g, '');

  // Limit to 10 digits
  digits = digits.slice(0, 10);

  // Format as XXX-XXX-XXXX
  let formatted = digits;
  if (digits.length > 6) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  } else if (digits.length > 3) {
    formatted = `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }

  input.value = formatted;
};

 window.validatePhone= function(phone) {
  // Remove non-digit characters and check for exactly 10 digits
  const digitsOnly = phone.replace(/\D/g, '');
  return /^\d{10}$/.test(digitsOnly);
}

  phoneInput.addEventListener("input", function () {
    if (!validatePhone(this.value)) {
      errorMessage.classList.remove("hidden");
    } else {
      errorMessage.classList.add("hidden");
    }
  });

  
  // this is for mini cart
  //const checkoutForm = document.querySelector("#CartDrawer-Form"); // Shopify's checkout form

   // this is for regular cart
  const checkoutForm = document.querySelector("#cart"); // Shopify's checkout form

 
  // Prevent checkout if phone number is missing when subscription is selected
 
  
  checkoutForm.addEventListener("submit", function (event) {
    const checkedSubscription = document.querySelector(".subscribe-reminder-checkbox:checked");
    const phoneNumber = phoneInput.value.trim();
    const subscriptionInterval = document.querySelector(".bundle-selling_plan_select");
   

    if (checkedSubscription && !validatePhone(phoneNumber)) {
      event.preventDefault(); //  Stop submission ONLY if invalid
      alert("Please enter a valid phone number before checking out.");
    }else if(checkedSubscription && !subscriptionInterval.value.trim()){
      event.preventDefault(); //  Stop submission ONLY if invalid
      alert("Please select re-order reminder interval.");
     
    }else{
       console.log("submit the form");
    }
     
  });
  

function updateCartUI(cartData, prType) {
   console.log("prType: "+prType);
  //var cartItemsContainer = document.querySelector(`.cart-item__details[data-id="${cartData.id}"]`);
   var propertyContainer = document.querySelector(`.product-option[data-id="${cartData.id}"]`);
 // var sellingPlanContainer = document.querySelector(`.selling-plan-details[data-id="${cartData.id}"]`);

console.log("Cart data id "+cartData.id);

  if (cartData.id && prType=="subscription") {
    console.log("Cart data for single item:", cartData);
    console.log("property container ", propertyContainer);

  
    if (propertyContainer) {
      console.log("adding plans info", cartData.id);

      propertyContainer.innerHTML =  Object.entries(cartData.properties)
          //  .filter(([key]) => key === "Re-order Reminder Interval") // Filter only "Re-order Interval"
            .map(([key, value]) => `
              <div class="product-option">
                <dt>${key}:</dt>
                <dd>${value}</dd>
              </div>
            `).join('');
   
    } 
 

  // Reattach event listeners to the updated items
 // attachCheckboxEventListeners();
}else{
  // regular product
  //  cartItemsContainer.innerHTML = '';
    propertyContainer.innerHTML = '';
  //  sellingPlanContainer.innerHTML = '';
 
}
}


  
  function fetchProductDetails(productHandle, callback) {
  fetch(`/products/${productHandle}.js`)
    .then((response) => response.json())
    .then((productData) => {
      callback(productData);
    })
    .catch((error) => {
      console.error("Error fetching product details:", error);
    });
}
 function initializeCartDrawerToggle() {
    const cartToggle = document.querySelector('.header__icon--cart');
    const cartDrawer = document.querySelector('.drawer');

    if (cartToggle && cartDrawer) {
      cartToggle.addEventListener('click', () => {
        cartDrawer.classList.toggle('active');

        // Once the cart drawer is opened, reattach event listeners for checkboxes
        if (cartDrawer.classList.contains('active')) {
        //  attachCheckboxEventListeners();
        }
      });
    }
  }

const observer = new MutationObserver(() => {
  const checkboxes = document.querySelectorAll('.subscribe-reminder-checkbox');
  if (checkboxes.length) {
    console.log("Checkboxes appeared:", checkboxes);
    attachCheckboxEventListeners();
  }
});
observer.observe(document.body, { childList: true, subtree: true });
  
  
});
